import { GrievanceModel } from './models/grievanceModel';
import { combineReducers } from 'redux';
import authSaga from './sagas/auth/authSagas';
import newAdmissionSaga from './sagas/in-patient/newAdmission.saga';
import hospitalSaga from './sagas/hospital/hospitalSagas';
import lookUpSaga from './sagas/in-patient/lookUpSaga';
import utilSaga from './sagas/utils/utilSagas';
import saveAsDraftSaga from './sagas/in-patient/saveAsDraft.saga';
import { AuthState } from './models/authModel';
import { authReducer } from './reducer/authReducer';
import { utilReducer } from './reducer/utilReducer';
import { payerReducer } from './reducer/payerListReducer';
import { fork, all } from 'redux-saga/effects';
import { PayerInitialState } from './models/payerListModel';
import { HospitalState } from './models/hospitalModel';
import hospitalReducer from './reducer/hospitalReducer';
import { NewAdmissionState } from './models/newAdmissionModel';
import { newAdmissionReducer } from './reducer/newAdmissionReducer';
import inPatientSaga from './sagas/in-patient/inPatient.saga';
import outPatientSaga from './sagas/out-patient/outPatient.saga';
import { inPatientReducer } from './reducer/inPatientReducer';
import { sideBarReducer } from './reducer/leftSideBarReducer';
import { LookUpState, PayerLookUpState } from './models/lookUpModel';
import { lookUpReducer, payerLookUpReducer } from './reducer/lookUpReducer';
import newAppointmentSaga from './sagas/out-patient/newAppointement.saga';
import claimDetailsSaga from './sagas/in-patient/claimDetailsSagas';
import { admissionDetailsReducer } from './reducer/claimDetailsReducer';
import sideBarSaga from './sagas/utils/leftSideBar.saga';
import { InventoryState } from './models/inventoryModel';
import inventoryReducer from './reducer/inventoryReducer';
import ineventorySaga from './sagas/inventory/inventorySagas';
import fileSaga from './sagas/in-patient/fileSagas';
import { UtilState } from './models/utilModels';
import frontDeskDetailSaga from './sagas/out-patient/frontDeskDetailSaga';
import { outPatientReducer } from './reducer/outPatientReducer';
import { newAppointmentReducer } from './reducer/newAppointmentReducer';
import forgetPasswordSaga from './sagas/auth/forgetPasswordSagas';
import SignUpSaga from './sagas/auth/signUpSagas';
import { applicationDetailReducer } from './reducer/applicationDetailReducer';
import { ApplicationDetailModel } from './models/applicationDetailModel';
import { savedDraftReducer } from './reducer/savedDraftReducers';
import { MailboxType } from './models/mailBoxModel';
import { mailBoxReducer } from './reducer/mailBoxReducer';
import mailBoxSaga from './sagas/hospital/mailBoxSagas';
import idCardSagas from './sagas/in-patient/idCardSagas';
import { IdCardReducer } from './reducer/idCardReducer';
import dashboardReducer from './reducer/dashboardReducer';
import dashboardSaga from './sagas/dashboardSaga';
import { blogsReducer } from './reducer/blogsReducer';
import { BlogsInitialState } from './models/blogsModel';
import grievanceReducer from './reducer/grievanceReducer';
import grievanceSaga from './sagas/grievance/grievanceSaga';
import abdmHUISaga from './sagas/abdm/abdmHIUSagas';
import linkContextSaga from './sagas/abdm/abdmLinkContextSagas';
import { ABDMHiuState } from './models/abdmHIUModel';
import { abdmHiuReducer } from './reducer/abdmHiuReducer';
import { LinkContextModel } from './models/linkContextModel';
import { linkContextReducer } from './reducer/linkContextReducer';
import watchReimbursementNewAdmission from './sagas/reimbursement/newAdmissionReimbursementSaga';
import { IReimbursementState } from './models/reimbursementModel';
import { reimbursementReducer } from './reducer/reimbursementReducer';
import { ReconciliationState } from './models/reconciliationModel';
import { reconciliationReducer } from './reducer/reconciliationReducer';
import reconciliationSaga from './sagas/reconciliation/reconciliationSaga';
import {nhcxReducer} from './reducer/nhcxReducer';
import { NHCXState } from './models/nhcxModel';
import nhcxSaga from './sagas/in-patient/nhcxSaga';
import { reportingAndAnalyticsReducer } from './reducer/reportingAndAnalyticsReducer';
import reportingAndAnalyticsSaga from './sagas/reportingAndAnalytics/reportingAndAnalyticsSaga';

export interface RootState {
  auth: AuthState;
  payerList: PayerInitialState;
  hospital: HospitalState;
  newAdmission: NewAdmissionState;
  reimbursement: IReimbursementState;
  selectedInPatientDetail: any;
  lookUp: LookUpState;
  payerLookUp: PayerLookUpState;
  newAppointment: any;
  admissionDetails: any;
  sideBarHeader: any;
  inventory: InventoryState;
  util: UtilState;
  frontDesk: any;
  applicationDetail: ApplicationDetailModel;
  savedDraft: any;
  mailBox: MailboxType;
  idCard: any;
  dashboard: any;
  blogs: BlogsInitialState;
  grievance: GrievanceModel;
  abdmHiu: ABDMHiuState;
  linkContext: LinkContextModel;
  reconciliation: ReconciliationState;
  nhcx: NHCXState;
  isShowingDoADoDEnhancementModal: boolean;
  reportingAndAnalytics: any;
}

export const createRootReducer = (): any =>
  combineReducers({
    mailBox: mailBoxReducer,
    auth: authReducer,
    payerList: payerReducer,
    hospital: hospitalReducer,
    newAdmission: newAdmissionReducer,
    reimbursement: reimbursementReducer,
    selectedInPatientDetail: inPatientReducer,
    lookUp: lookUpReducer,
    payerLookUp: payerLookUpReducer,
    admissionDetails: admissionDetailsReducer,
    sideBarHeader: sideBarReducer,
    util: utilReducer,
    newAppointment: newAppointmentReducer,
    frontDesk: outPatientReducer,
    inventory: inventoryReducer,
    applicationDetail: applicationDetailReducer,
    savedDraft: savedDraftReducer,
    idCard: IdCardReducer,
    dashboard: dashboardReducer,
    blogs: blogsReducer,
    grievance: grievanceReducer,
    abdmHiu: abdmHiuReducer,
    linkContext: linkContextReducer,
    reconciliation: reconciliationReducer,
    nhcx: nhcxReducer,
    reportingAndAnalytics: reportingAndAnalyticsReducer,
  });

export function* rootSaga(): Generator {
  yield all(
    [
      fork(authSaga), fork(hospitalSaga), fork(newAdmissionSaga),
      fork(saveAsDraftSaga), fork(inPatientSaga), fork(outPatientSaga), fork(sideBarSaga),
      fork(lookUpSaga), fork(newAppointmentSaga), fork(fileSaga),
      fork(claimDetailsSaga), fork(frontDeskDetailSaga), fork(utilSaga), fork(ineventorySaga), fork(forgetPasswordSaga), fork(SignUpSaga),
      fork(mailBoxSaga), fork(idCardSagas), fork(dashboardSaga), fork(grievanceSaga), fork(abdmHUISaga), fork(linkContextSaga),
      fork(watchReimbursementNewAdmission), fork(reconciliationSaga), fork(nhcxSaga), fork(reportingAndAnalyticsSaga),
    ]);
}
